import { createEvent, createStore } from 'effector';
import type { Store } from '@/types/store';

export const setStore = createEvent<Store>();
export const clearStore = createEvent();
export const setStoreList = createEvent<Store[]>();
export const resetStores = createEvent();
export const setQrCode = createEvent<string>();

export const $store = createStore<Store | null>(null)
  .on(setStore, (_, store) => store)
  .reset(clearStore)
  .reset(resetStores);
export const $storeList = createStore<Store[]>([])
  .on(setStoreList, (_, stores) => stores)
  .reset(resetStores);
export const $qrCode = createStore('')
  .on(setQrCode, (_, code) => code)
  .reset(resetStores);
